import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { RegistrationService } from 'src/app/services/registration-service/registration.service';

const userMessageNewMail: string = 'Verifizierung abgeschlossen';
const userMessageDetailNewMail: string =
    'Sie können sich nun mit Ihrer neuen E-Mail anmelden.';
const userMessageOldMail: string = 'Bestätigung erfolgreich';
const userMessageDetailOldMail: string =
    'Es wurde eine Bestätigung an Ihre neue E-Mail versendet. Bitte bestätigen Sie diese, um fortzusetzen.';

@Component({
    selector: 'app-verify-user-name',
    templateUrl: './verify-user-name.component.html',
    styleUrls: ['./verify-user-name.component.css'],
    standalone: false
})
export class VerifyUserNameComponent implements OnInit {
    private userMessage: string = '';
    private userMessageDetail: string = '';

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private registrationService: RegistrationService,
        private dialogService: DialogService
    ) {}

    ngOnInit() {
        this.route.queryParamMap.subscribe((params) => {
            const token = params.get('code');
            const isNewMail: boolean = this.router.url.includes('verify_new');
            this.registrationService
                .verifyNewUserName(token, isNewMail)
                .subscribe(
                    (_) => {
                        this.chooseUserMessage(isNewMail);
                        const modalResult = this.dialogService.openDialog(
                            this.userMessage,
                            this.userMessageDetail
                        );
                        modalResult.subscribe((_) => {
                            this.router.navigate(['marktplatz']);
                        });
                    },

                    (errorObj) => {
                        this.handleVerifyError(errorObj.error);
                    }
                );
        });
    }

    private chooseUserMessage(isNewMail: boolean): void {
        if (isNewMail) {
            this.userMessage = userMessageNewMail;
            this.userMessageDetail = userMessageDetailNewMail;
        } else {
            this.userMessage = userMessageOldMail;
            this.userMessageDetail = userMessageDetailOldMail;
        }
    }

    handleVerifyError(error) {
        this.router.navigate(['/']);
    }
}
